import { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { sendContact } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ full_name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await sendContact(form);
      toast.success("Message envoyé. Nous vous répondons sous 24 heures.");
      setForm({ full_name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Une erreur est survenue, réessayez.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Header />
      <section className="pt-32 pb-24 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline">Nous contacter</p>
          <h1 className="text-4xl md:text-6xl font-black tracking-tighter mt-3">
            Une question<span className="text-primary">?</span>
          </h1>
          <p className="text-muted-foreground mt-6 leading-relaxed max-w-md">
            Notre équipe vous répond en 24 heures. Pour toute question concernant votre commande,
            indiquez votre numéro de transaction.
          </p>
          <div className="mt-10 space-y-5">
            <div className="flex items-center gap-3">
              <Mail size={16} className="text-primary" />
              <span className="font-mono text-sm">support@spectralivefrance.com</span>
            </div>
            <div className="flex items-center gap-3">
              <Phone size={16} className="text-primary" />
              <span className="font-mono text-sm">+33 1 23 45 67 89</span>
            </div>
            <div className="flex items-center gap-3">
              <MapPin size={16} className="text-primary" />
              <span className="font-mono text-sm">Paris, France</span>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 border border-white/10 bg-card rounded-sm p-6 md:p-10 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">Nom complet</label>
              <input
                required
                type="text"
                value={form.full_name}
                onChange={(e) => setForm({ ...form, full_name: e.target.value })}
                className="mt-2 w-full bg-input border border-white/10 rounded-sm px-4 py-3 text-sm focus:border-primary outline-none"
                data-testid="contact-name-input"
              />
            </div>
            <div>
              <label className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">E-mail</label>
              <input
                required
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-2 w-full bg-input border border-white/10 rounded-sm px-4 py-3 text-sm focus:border-primary outline-none"
                data-testid="contact-email-input"
              />
            </div>
          </div>
          <div>
            <label className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">Sujet</label>
            <input
              required
              type="text"
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              className="mt-2 w-full bg-input border border-white/10 rounded-sm px-4 py-3 text-sm focus:border-primary outline-none"
              data-testid="contact-subject-input"
            />
          </div>
          <div>
            <label className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">Message</label>
            <textarea
              required
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="mt-2 w-full bg-input border border-white/10 rounded-sm px-4 py-3 text-sm focus:border-primary outline-none resize-none"
              data-testid="contact-message-input"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3.5 rounded-sm font-bold text-sm hover:brightness-110 disabled:opacity-50"
            data-testid="contact-submit-btn"
          >
            {busy ? "Envoi…" : <>Envoyer <Send size={14} /></>}
          </button>
        </form>
      </section>
      <Footer />
    </>
  );
}
